document.addEventListener('DOMContentLoaded', () => {
  let psdWrapper = document.querySelector('.password-input-wrapper');
  let btnPsdShow = psdWrapper.querySelector('.password-show');
  let btnPsdHide = psdWrapper.querySelector('.password-hide');
  if(btnPsdShow && btnPsdHide) {
    btnPsdShow.addEventListener('click', () => {
      psdWrapper.querySelector('input').setAttribute('type', 'text');
    })
    btnPsdHide.addEventListener('click', () => {
      psdWrapper.querySelector('input').setAttribute('type', 'password');
    })
  }
})